import HomeComponent from "./Component";

const Home = () => {
  return <HomeComponent />;
};

export default Home;
